import i18n, { currentLocale } from '@/i18n';
import type { CategoryOption } from '@/types';

const legacySlugs: Record<string, string> = {
  历史: 'history', 飞机: 'aircraft', 航展: 'airshows', 行业: 'industry',
};

export function categorySlug(value: string, options: CategoryOption[] = []): string {
  const match = options.find((option) => option.slug === value) ?? options.find((option) => (
    option.name_zh === value || option.name_en === value
  ));
  return match?.slug ?? value;
}

export function categoryOptionLabel(option: CategoryOption): string {
  return currentLocale() === 'en' ? option.name_en : option.name_zh;
}

export function categoryLabel(event: {
  category: string | null;
  category_slug?: string | null;
  category_name_en?: string | null;
}): string {
  if (!event.category) {
    return '';
  }
  if (currentLocale() === 'en' && event.category_name_en) {
    return event.category_name_en;
  }
  if (currentLocale() === 'zh-CN' && event.category_slug) {
    return event.category;
  }
  const slug = event.category_slug ?? legacySlugs[event.category] ?? event.category;
  return i18n.t(`common:categories.${slug}`, { defaultValue: event.category });
}
